import { render, staticRenderFns } from "./SalesRankingList.vue?vue&type=template&id=33ba3574&scoped=true"
import script from "./SalesRankingList.vue?vue&type=script&lang=js"
export * from "./SalesRankingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ba3574",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33ba3574')) {
      api.createRecord('33ba3574', component.options)
    } else {
      api.reload('33ba3574', component.options)
    }
    module.hot.accept("./SalesRankingList.vue?vue&type=template&id=33ba3574&scoped=true", function () {
      api.rerender('33ba3574', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/sales-ranking/SalesRankingList.vue"
export default component.exports